import { i18n } from "@tellescope/i18n";

/**
 * Maps a raw SDK/validator error — written for an API caller, in English — onto a patient-facing
 * message in the active language. An unrecognized error is returned unchanged.
 */
export const translateValidatorError = (error: string): string => {
  switch (error) {
    case "missing value":
      return i18n.t("This field is required", { ns: "forms" });
    case "Expecting a list of values but list is empty":
      return i18n.t("Please make a selection", { ns: "forms" });
    case "Arrays should not contain more than 1000 elements":
      return i18n.t("Too many selections", { ns: "forms" });
    case "Value has 0 length after escaping but field is required":
      return i18n.t("Please enter a valid value", { ns: "forms" });
    case "Expecting string value":
      return i18n.t("Please enter a valid value", { ns: "forms" });
    case "Phone number must be at least 10 digits":
      return i18n.t("Phone number must be at least 10 digits", { ns: "forms" });
    case "Response must be a number":
      return i18n.t("Response must be a number", { ns: "forms" });
    case "Not a valid number":
      return i18n.t("Please enter a valid number", { ns: "forms" });
    case "Invalid date":
      return i18n.t("Please enter a valid date", { ns: "forms" });
    // Literal bug in source — ${object} is not interpolated
    case "Expected a non-null object by got ${object}":
      return i18n.t("Please provide a valid response", { ns: "forms" });
    case "Value must match one of file":
      return i18n.t("Please upload a file", { ns: "forms" });
    case "Value must match one of signature":
      return i18n.t("Please complete the signature", { ns: "forms" });
    case "Invalid boolean":
      return i18n.t("Please complete the signature", { ns: "forms" });
    case "At least 1 choice is required":
      return i18n.t("At least 1 choice is required", { ns: "forms" });
    case "No options provided":
      return i18n.t("No options provided", { ns: "forms" });
    case "Only 1 choice is allowed":
      return i18n.t("Only 1 choice is allowed", { ns: "forms" });
  }

  if (/^Expecting non-empty string but got/.test(error)) return i18n.t("Please enter a valid value", { ns: "forms" });
  if (/^Expecting an object but got/.test(error)) return i18n.t("Please provide a valid response", { ns: "forms" });
  if (/^Expecting a list of values but got/.test(error)) return i18n.t("Please make a selection", { ns: "forms" });
  if (/^Length of escapedValue .+ exceeds maxLength/.test(error))
    return i18n.t("Response exceeds maximum length", { ns: "forms" });
  if (/^Length of JSON .+ exceeds maxLength/.test(error))
    return i18n.t("Response exceeds maximum length", { ns: "forms" });
  if (/^Invalid email:/.test(error)) return i18n.t("Please enter a valid email address", { ns: "forms" });
  if (/^Expecting phone to be string but got/.test(error))
    return i18n.t("Please enter a valid phone number", { ns: "forms" });
  if (/^Invalid phone number:/.test(error)) return i18n.t("Please enter a valid phone number", { ns: "forms" });
  if (/^Not a valid number for/.test(error)) return i18n.t("Please enter a valid number", { ns: "forms" });
  if (/^Choice .+ is not a valid index$/.test(error)) return i18n.t("Invalid choice selected", { ns: "forms" });
  if (/^Value must match one of/.test(error)) return i18n.t("Please provide a valid response", { ns: "forms" });

  return error;
};
